import { FC } from 'react';

import { Textarea } from '../../../shared/ui';

interface IProps {
  /** «Задание для клиента» либо «Текст домашнего задания». */
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Серверный лимит длины: ввод стопорится, чтобы запрос не упал валидацией. */
  maxLength?: number;
  /** Задание уже отправлено клиенту — поле только для чтения. */
  disabled?: boolean;
}

/** Блок «Задание для клиента» — подвал карточки инструмента в разделе отправки. */
export const ClientTaskBlock: FC<IProps> = ({ label, value, onChange, placeholder, maxLength, disabled }) => (
  <div className="flex flex-col gap-3 border-t border-line bg-surface-muted p-[32px_22px_20px]">
    <div className="flex flex-wrap items-baseline justify-between gap-4">
      <span className="text-body-l-strong text-ink">{label}</span>
      <span className="text-ui-s text-ink-subtle">
        {disabled ? 'Домашнее задание уже отправлено' : 'Клиент увидит текст вместе с инструментом'}
        {maxLength ? ` · ${value.length} / ${maxLength}` : ''}
      </span>
    </div>

    <Textarea
      aria-label={label}
      value={value}
      rows={3}
      maxLength={maxLength}
      disabled={disabled}
      placeholder={placeholder ?? 'Задание для клиента по этому инструменту'}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);
